<template>
  <th>
    <div
      v-if="label"
      class="size-full"
      :aria-label="label"
      :data-balloon-pos="pos"
      data-balloon-blunt
    >
      <slot/>
    </div>
    <slot v-else/>
  </th>
</template>

<script setup>
import { computed } from "vue"

const props = defineProps({
  title: { type: String },
  ariaLabel: { type: String },
  pos: { type: String, default: "down" },
  year: Number,
})

const label = computed(() => {
  return props.ariaLabel || props.title
})
</script>
